import React from 'react';
import { Target, Code, Palette, Sparkles } from 'lucide-react';

const steps = [
  {
    icon: Target,
    title: 'Choose Component',
    description: 'Select the type of HTML component you want to generate.'
  },
  {
    icon: Code,
    title: 'Customize Options',
    description: 'Pick your style and add any custom elements needed.'
  },
  {
    icon: Palette,
    title: 'Generate Code',
    description: 'Our AI creates clean, semantic HTML based on your choices.'
  },
  {
    icon: Sparkles,
    title: 'Copy & Use',
    description: 'Copy the generated code and use it in your project.'
  }
];

export default function HTMLHowItWorks() {
  return (
    <section className="py-20 bg-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
          How Our HTML Generator Works
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-8 left-1/2 w-full h-0.5 bg-blue-200"></div>
              )}
              <div className="relative text-center">
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-100 mb-4">
                  <step.icon className="w-8 h-8 text-blue-600" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">{step.title}</h3>
                <p className="text-gray-600">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}